import { defineMessages } from 'react-intl'

export default defineMessages({
  placeholder: {
    id: 'containers.CustomerOrderUpsertPage.components.Text.placeholder',
    defaultMessage: 'Enter {name} here..',
  },
})
